export const labelSizes = {
   ExtraSmall: {
      typography: 'text-xs-medium',
      requiredContentClassName: 'ml-4px pt-4px',
      margin: 'mb-6px'
   },
   Small: {
      typography: 'text-sm-medium',
      requiredContentClassName: 'ml-4px pt-4px',
      margin: 'mb-6px'
   },
   Medium: {
      typography: 'text-sm-medium',
      requiredContentClassName: 'ml-4px pt-4px',
      margin: 'mb-6px'
   }
}
